<div class="screen-element screen-week-overview">
	<div #titleElement [ngStyle]="{'opacity':1}" class="text title">{{tr('TIMEWINDOWS_DAYS_TITLE')}}</div>
	<div #titleElement2 [ngStyle]="{'opacity':1}" class="text subtitle">{{subtitle}}</div>
	<!--<div class="marker"></div>-->
	<div class="days-overview-header"><span class="headerelement" *ngFor="let hour of [0, 3, 6, 9, 12, 15, 18, 21, 24]">{{hour}}</span></div>
	<div class="day-overviews">
		<div class="day-overview-wrap" ><!-- top-mover -->
			<div class="day" *ngFor="let day of [0,1,2,3,4,5,6]">
				<app-day-overview [table]="table" [selected]="isSelected(day)" [day]="day" [zone]="zone"></app-day-overview>  
			</div>
		</div>
	</div>
</div>

